import Layout from "../../components/Layout";
import SMTPClient from "../../images/systemComponents/SMTPClient.png";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1 className="mb-4 ">
                    SMTP клиент
                </h1>
                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        Использование <b>SMTP (Simple Mail Transfer Protocol) клиента</b> в SCADA NPT Compact решает задачи, связанные с отправкой уведомлений, оповещений и отчетов по электронной почте. SMTP — это стандартный протокол для передачи электронной почты, который позволяет SCADA-системам автоматически отправлять сообщения в случае возникновения событий, аварий или других важных ситуаций.
                    </p>
                    <img
                        src={SMTPClient}
                        className="mb-4 w-100 "
                        alt="SMTP Клиент"
                    />

                    <p>Основные задачи, которые решает использование SMTP клиента в SCADA NPT Compact, включают:</p>

                    <ul className="mb-4 description__list">

                        <li className="mb-1 description__number-li"><b>Оповещение о событиях и авариях</b>
                            <ul>
                                <li>SMTP клиент позволяет SCADA-системе отправлять уведомления по электронной почте в случае:
                                    <ul>
                                        <li>Аварийных ситуаций (например, срабатывание защит, отключение оборудования).</li>
                                        <li>Превышения критических параметров (например, температура, давление, напряжение).</li>
                                        <li>Изменения состояния оборудования (включение/выключение, переход в аварийный режим).</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Отправка отчетов</b>
                            <ul>
                                <li>SMTP клиент может использоваться для автоматической отправки отчетов по электронной почте, таких как:
                                    <ul>
                                        <li>Суточные, недельные или месячные отчеты о работе системы.</li>
                                        <li>Отчеты о потреблении энергии, воды или других ресурсов.</li>
                                        <li>Логи событий и аварийных ситуаций.</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Уведомление персонала</b>
                            <ul>
                                <li>SMTP клиент позволяет отправлять уведомления персоналу (операторам, инженерам, руководителям) о необходимости вмешательства в работу системы, например:
                                    <ul>
                                        <li>Требование выполнить определенные действия (например, перезапуск оборудования).</li>
                                        <li>Информирование о плановых работах или изменениях в системе.</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Интеграция с системами управления инцидентами</b>
                            <ul>
                                <li>SMTP клиент может использоваться для отправки уведомлений в системы управления инцидентами (например, ITSM-системы), что позволяет автоматически создавать заявки на устранение неисправностей.

                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Поддержка работы в автономном режиме</b>
                            <ul>
                                <li>SMTP клиент может быть настроен на отправку уведомлений даже в случае временного отсутствия связи с почтовым сервером (например, с использованием очереди сообщений).

                                </li>
                            </ul>
                        </li>


                    </ul>
                    <p>
                        <b>Примеры использования SMTP клиента в SCADA-системах:</b>
                    </p>
                    <ul>
                        <li><b>Энергетика:</b> оповещение о срабатывании защит на подстанциях, отправка отчетов о потреблении энергии.</li>
                        <li><b>Промышленность:</b> уведомление о неисправностях оборудования, отправка отчетов о производственных процессах.</li>
                        <li><b>Водоснабжение:</b> оповещение о превышении уровня воды, отправка отчетов о потреблении воды.</li>
                        <li><b>Транспорт:</b> уведомление о неисправностях светофоров, отправка отчетов о состоянии инфраструктуры.</li>
                    </ul>
                </div>

            </div>
        </div>
    </Layout>
}
